import React, { FC } from 'react'
import { addSeconds } from 'date-fns'

import { convertDateToDateYearString } from '../../../../../helpers/DateTimeParser'
import { InfoListItem } from '../../../../components'
import { LeaveOfAbsence } from '../../../../entities/LeaveOfAbsences/LeaveOfAbsences'
import {
    getLeaveOfAbsencesDateLabelShort,
} from '../../../../entities/LeaveOfAbsences/LeaveOfAbsencesHelpers'
import { addDays, differenceInDays } from '../../../../helpers/date'
import trans from '../../../../helpers/trans'
import { leaveOfAbsenceStatus, LeaveOfAbsenceStatusTypes } from '../../../../types/LeaveOfAbsenceStatusTypes'

import './LeaveOfAbsenceDetailList.scss'

interface LeaveOfAbsenceDetailListProps {
    leaveOfAbsence?: LeaveOfAbsence;
    className?: string;
}

const LeaveOfAbsenceDetailList: FC<LeaveOfAbsenceDetailListProps> = ({
    leaveOfAbsence,
    className = '',
}) => {
    const status = leaveOfAbsence ? leaveOfAbsence.status : {} as LeaveOfAbsenceStatusTypes
    const { label } = leaveOfAbsenceStatus[status]

    const daysBetween = differenceInDays(addSeconds(leaveOfAbsence!.period.end, -2), leaveOfAbsence!.period.start)

    return (
        <ul className={`leave-of-absence-detail-list ${className}`}>
            <InfoListItem
                label={trans('containers.leaveOfAbsenceDetailContainer.leaveOfAbsenceRequestedOn')}
                className="leave-of-absence-detail-list__item"
            >
                {getLeaveOfAbsencesDateLabelShort(leaveOfAbsence?.createdAt)}
            </InfoListItem>

            <InfoListItem
                label={trans('containers.leaveOfAbsenceDetailContainer.leaveOfAbsenceStartDate')}
                className="leave-of-absence-detail-list__item"
            >
                {getLeaveOfAbsencesDateLabelShort(leaveOfAbsence?.period.start)}
            </InfoListItem>

            <InfoListItem
                label={trans('containers.leaveOfAbsenceDetailContainer.leaveOfAbsenceEndDate')}
                className="leave-of-absence-detail-list__item"
            >
                {convertDateToDateYearString(addDays(leaveOfAbsence!.period.start, daysBetween))}
            </InfoListItem>

            <InfoListItem
                label={trans('containers.leaveOfAbsenceDetailContainer.leaveOfAbsenceReason')}
                className="leave-of-absence-detail-list__item"
            >
                {leaveOfAbsence?.reason}
            </InfoListItem>

            <InfoListItem
                label={trans('containers.leaveOfAbsenceDetailContainer.leaveOfAbsenceStatus')}
                className="leave-of-absence-detail-list__item"
            >
                {label}
            </InfoListItem>
        </ul>
    )
}

export default LeaveOfAbsenceDetailList
